import { Header } from 'shared/ui/Header/Header'
import { EmptyState } from 'shared/ui/EmptyState/EmptyState'
import { Chat2, Plus } from 'shared/assets/icons'
import { Button } from 'shared/ui/Button/Button'
import { useNavigate } from 'react-router-dom'

export const Empty = () => {
  const navigate = useNavigate()

  const onNew = () => {
    navigate('1?new')
  }
  return (
    <>
      <Header title={'Inbox'} />
      <EmptyState
        title={'Create your first conversation'}
        description={'Send message to drive sales or for reminders'}
        IconFC={Chat2}
        actions={
          <Button
            variant={'primary-medium'}
            text={'New conversation'}
            LeftIcon={Plus}
            onClick={onNew}
          />
        }
      />
    </>
  )
}
